/**
 * Element.closest Polyfill
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 */
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
(function(){
    // delegate event
    var paginationElem = document.querySelector('.nooz-pagination');
    if (paginationElem) paginationElem.addEventListener('click', function(e){
        if (e.target.matches('.more')) {
            e.preventDefault();
            var posts_selector = paginationElem.getAttribute('data-posts-selector');
            var posts_container = document.querySelector(posts_selector ? posts_selector : '.nooz-posts');
            var query =  JSON.parse(posts_container.getAttribute('data-query'));

            var paged = posts_container.getAttribute('data-paged');
            var max_num_pages = posts_container.getAttribute('data-max-num-pages');
            paged++;
            query.paged = paged;
            posts_container.setAttribute('data-paged', paged);

            posts_container.setAttribute('data-query', JSON.stringify(query));
            //console.log(query);
            // ajax
            var req = new XMLHttpRequest();
            req.open('POST', nooz.ajax_url + '?action=nooz_get_posts&_ajax_nonce=' + nooz.get_posts_nonce, true);
            req.setRequestHeader('Content-type', 'application/json');
            req.onload = function() {
                // create virtual element
                var placeholder = document.createElement('div');
                placeholder.innerHTML = req.responseText;
                var postsElem = placeholder.querySelector('.nooz-posts');
                // use inner html or all
                //posts_container.innerHTML = '';
                posts_container.insertAdjacentHTML('beforeend', postsElem ? postsElem.innerHTML : req.responseText);
                // set "end" (e.g. no more pages)
                if ( paged >= max_num_pages) paginationElem.className += ' end';
            };
            // network level error
            // req.onerror = function() {}
            req.send(JSON.stringify(query));
        }
    }, false);
})();
